import { Injectable } from '@angular/core';
import { EnteEsecutore } from '../models/ente.model';
import { Richiesta } from '../models/richiesta.model';
import { StoricoRichiesta } from '../models/storico-richiesta.model';
import { StatoRichiestaEnum } from '../models/stato-richiesta.model';
import { OggettoIntervento } from '../models/oggetto-intervento.model';

@Injectable({
  providedIn: 'root',
})
export class StiliService {
  getMaterialIconEnteEsecutore(enteEsecutore: EnteEsecutore): string {
    switch (enteEsecutore.categoria.codice) {
      case 'COMUNE':
        return 'location_city';
      case 'CONSORZIO':
        return 'group_work';
      case 'UMVS':
        return 'hub';
      default:
        return 'location_city';
    }
  }

  getColoreIconaEnteEsecutore(enteEsecutore: EnteEsecutore): string {
    switch (enteEsecutore.categoria.codice) {
      case 'COMUNE':
        return '#1C56AC';
      case 'CONSORZIO':
        return '#02394A';
      case 'UMVS':
        return '#006400';
      default:
        return '#1C56AC';
    }
  }

  getMaterialIconStatoRichiesta(richiesta: Richiesta): string {
    switch (richiesta.stato.descrizione) {
      case 'IN PREPARAZIONE':
        return 'edit_document';
      case 'PRESENTATA':
        return 'assignment_turned_in';
      case 'DA RIMODULARE':
        return 'calculate';
      case 'DA FINANZIARE':
        return 'shopping_cart_checkout';
      case 'FINANZIATA':
        return 'payments';
      case 'IN RENDICONTAZIONE':
        return 'receipt_long';
      case 'RENDICONTATA':
        return 'pending_actions';
      default:
        return 'edit_document';
    }
  }

  getColoreIconaStatoRichiesta(richiesta: Richiesta): string {
    switch (richiesta.stato.descrizione) {
      case 'IN PREPARAZIONE':
        return '#5158BB';
      case 'PRESENTATA':
        return '#619496';
      case 'DA RIMODULARE':
        return '#2196F3';
      case 'DA FINANZIARE':
        return '#eabf51';
      case 'FINANZIATA':
        return '#17B890';
      case 'IN RENDICONTAZIONE':
        return '#e3b23e';
      case 'RENDICONTATA':
        return '#4CAF50';
      default:
        return '#5158BB';
    }
  }

  getColoreAnnoRichiesta(richiesta: Richiesta): string {
    const annoCorrente = new Date().getFullYear();
    switch (richiesta.anno) {
      case annoCorrente:
        return '#17B890';
      case annoCorrente - 1:
        return '#7EBDC2';
      case annoCorrente - 2:
        return '#5998C5';
      case annoCorrente - 3:
        return '#443742';
      case annoCorrente - 4:
        return '#e3b23e';
      case annoCorrente - 5:
        return '#8FB8ED';
      case annoCorrente - 6:
        return '#C2BBF0';
      case annoCorrente - 7:
        return '#5158BB';
      default:
        return '#5158BB';
    }
  }

  getColoreAnnoIntervento(anno: number): string {
    const annoCorrente = new Date().getFullYear();
    switch (anno) {
      case annoCorrente:
        return '#17B890';
      case annoCorrente - 1:
        return '#69EBD0';
      case annoCorrente - 2:
        return '#619496';
      case annoCorrente - 3:
        return '#62BFED';
      case annoCorrente - 4:
        return '#e3b23e';
      case annoCorrente - 5:
        return '#8FB8ED';
      case annoCorrente - 6:
        return '#C2BBF0';
      case annoCorrente - 7:
        return '#5158BB';
      default:
        return '#5158BB';
    }
  }

  getColoreFrequenzaIntervento(frequenza: number | null): string {
    switch (frequenza) {
      case 1:
        return '#B5EAD7'; // Verde menta pastello
      case 2:
        return '#C7CEEA'; // Azzurro lavanda pastello
      case 3:
        return '#B8E0D2'; // Verde acquamarina pastello
      case 4:
        return '#FFDAC1'; // Pesca pastello
      case 5:
        return '#E2F0CB'; // Verde lime pastello
      case 6:
        return '#D4E2D4'; // Salvia chiaro pastello
      case 7:
        return '#CDF1AF'; // Verde pistacchio pastello
      case 8:
        return '#BEAEE2'; // Viola lavanda pastello
      case 9:
        return '#FFCBC1'; // Salmone pastello
      case 10:
        return '#FFF9C1'; // Giallo pastello
      case 11:
        return '#A2D2FF'; // Azzurro cielo pastello
      case 12:
        return '#DAE5D0'; // Verde salvia pastello
      default:
        return '#F1FAEE'; // Bianco-verde pastello per il default
    }
  }

  getMaterialIconStoricoRichiesta(storicoRichiesta: StoricoRichiesta): string {
    switch (storicoRichiesta.stato.descrizione) {
      case StatoRichiestaEnum.IN_PREPARAZIONE:
        return 'edit_document';
      case StatoRichiestaEnum.PRESENTATA:
        return 'assignment_turned_in';
      case StatoRichiestaEnum.FINANZIATA:
        return 'payments';
      case StatoRichiestaEnum.RENDICONTATA:
        return 'receipt_long';
      default:
        return 'edit_document';
    }
  }

  getColoreIconaStoricoRichiesta(storicoRichiesta: StoricoRichiesta): string {
    switch (storicoRichiesta.stato.descrizione) {
      case StatoRichiestaEnum.IN_PREPARAZIONE:
        return '#5158BB';
      case StatoRichiestaEnum.PRESENTATA:
        return '#619496';
      case StatoRichiestaEnum.FINANZIATA:
        return '#17B890';
      case StatoRichiestaEnum.RENDICONTATA:
        return '#e3b23e';
      default:
        return '#5158BB';
    }
  }
  getColoreCodiceAto(codiceAto: string): string {
    // Convertiamo il codice in stringa per gestire sia numeri che stringhe
    const codice = codiceAto.toString();

    // Definiamo una palette di colori pastello
    const colori: { [key: string]: string } = {
      '1': '#B5EAD7', // Verde menta
      '2': '#C7CEEA', // Blu pastello
      '3': '#FFDAC1', // Pesca
      '4': '#E2F0CB', // Verde chiaro
      '5': '#FFB7B2', // Rosa
      '6': '#B5EAD7', // Verde menta
      '7': '#C7CEEA', // Blu pastello
      '8': '#FFDAC1', // Pesca
      '9': '#E2F0CB', // Verde chiaro
      '10': '#FFB7B2', // Rosa
      '11': '#B5EAD7', // Verde menta
      '12': '#C7CEEA', // Blu pastello
      '13a': '#FFDAC1', // Pesca
      '13b': '#E2F0CB', // Verde chiaro
      '13c': '#FFB7B2', // Rosa
      '13d': '#B5EAD7', // Verde menta
      '13e': '#C7CEEA', // Blu pastello
      '13f': '#FFDAC1', // Pesca
      '13g': '#E2F0CB', // Verde chiaro
    };

    return colori[codice] || '#F1FAEE'; // Ritorna il colore corrispondente o un colore default
  }
  getColoreOggettoIntervento(oggettoIntervento: OggettoIntervento): string {
    switch (oggettoIntervento.codice) {
      case 'AL':
        return '#B5EAD7'; // Verde menta pastello
      case 'AP':
        return '#C7CEEA'; // Azzurro lavanda pastello
      case 'AR':
        return '#FFB7B2'; // Rosa pastello
      case 'AT':
        return '#FFDAC1'; // Pesca pastello
      case 'AV':
        return '#E2F0CB'; // Verde lime pastello
      case 'DD':
        return '#F7DBF0'; // Rosa chiaro pastello
      case 'DS':
        return '#CDF1AF'; // Verde pistacchio pastello
      case 'OA':
        return '#BEAEE2'; // Viola lavanda pastello
      case 'OI':
        return '#FFCBC1'; // Salmone pastello
      case 'OS':
        return '#FFF9C1'; // Giallo pastello
      case 'OT':
        return '#A2D2FF'; // Azzurro cielo pastello
      case 'OV':
        return '#FFC8DD'; // Rosa orchidea pastello
      case 'PC':
        return '#BDE0FE'; // Azzurro polvere pastello
      case 'SA':
        return '#FDFFB6'; // Giallo limone pastello
      case 'SG':
        return '#D8E2DC'; // Verde salvia pastello
      case 'SP':
        return '#FAD2E1'; // Rosa pallido pastello
      case 'SS':
        return '#E4C1F9'; // Viola glicine pastello
      case 'VD':
        return '#F4ACB7'; // Rosa corallo pastello
      case 'VF':
        return '#9CF6F6'; // Turchese pastello
      case 'VG':
        return '#F4D1AE'; // Albicocca pastello
      case 'VM':
        return '#FFE5D9'; // Pesca chiaro pastello
      case 'VV':
        return '#D0F4DE'; // Verde acqua pastello
      default:
        return '#F1FAEE'; // Bianco-verde pastello per il default
    }
  }

  getIconaAccessibilita(idAccessibilita: number): string {
    switch (idAccessibilita) {
      case 1:
        return 'directions_car'; // Camion/qualsiasi mezzo
      case 2:
        return 'ph-jeep'; // Auto standard
      case 3:
        return 'ph-bulldozer'; // Mezzi speciali
      case 4:
        return 'directions_walk'; // A piedi
      case 5:
        return 'hiking'; // Difficilmente accessibile
      case 6:
        return 'block'; // Non accessibile
      default:
        return 'help_outline';
    }
  }

  getClasseIconaAccessibilita(idAccessibilita: number): string {
    switch (idAccessibilita) {
      case 1:
        return 'material-icons'; // Camion/qualsiasi mezzo
      case 2:
        return 'ph'; // Auto standard
      case 3:
        return 'ph';
      case 4:
        return 'material-icons'; // A piedi
      case 5:
        return 'material-icons'; // Difficilmente accessibile
      case 6:
        return 'material-icons';
      default:
        return 'material-icons'; // Mezzi speciali
    }
  }

  getColoreBackgroundAccessibilita(idAccessibilita: number): string {
    switch (idAccessibilita) {
      case 1:
        return '#AAE79D'; // Verde pastello - facile
      case 2:
        return '#99C98E'; // Azzurro pastello - standard
      case 3:
        return '#E2B878'; // Giallo pastello - mezzi speciali
      case 4:
        return '#FFDAC1'; // Pesca pastello - a piedi
      case 5:
        return '#FFCBC1'; // Salmone pastello - difficile
      case 6:
        return '#D3D3D3'; // Grigio chiaro - non accessibile
      default:
        return '#F1FAEE';
    }
  }

  getColoreIconaAccessibilita(idAccessibilita: number): string {
    switch (idAccessibilita) {
      case 1:
        return '#000000'; // Verde scuro
      case 2:
        return '#000000'; // Blu scuro
      case 3:
        return '#000000'; // Bianco
      case 4:
        return '#000000'; // Arancione mattone
      case 5:
        return '#000000'; // Rosso medio
      case 6:
        return '#000000'; // Rosso scuro
      default:
        return '#000000';
    }
  }

  getStileAccessibilita(idAccessibilita: number): any {
    return {
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      width: '40px',
      height: '40px',
      'border-radius': '50%',
      margin: '0 auto',
      'background-color':
        this.getColoreBackgroundAccessibilita(idAccessibilita),
      color: this.getColoreIconaAccessibilita(idAccessibilita),
    };
  }
  getStileAccessibilitaSpeciale(idAccessibilita: number): any {
    return {
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      width: '25px',
      height: '25px',
      'border-radius': '50%',
      margin: '0 auto',
      'background-color':
        this.getColoreBackgroundAccessibilita(idAccessibilita),
      color: this.getColoreIconaAccessibilita(idAccessibilita),
    };
  }

  getStileIconaAccessibilita(idAccessibilita: number): any {
    // Riduci la dimensione dell'icona per il componente dialogo
    return {
      'font-size': idAccessibilita === 3 ? '18px' : '22px',
    };
  }

  getStileAccessibilitaCompatto(idAccessibilita: number): any {
    return {
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      width: '28px',
      height: '28px',
      'border-radius': '50%',
      'background-color':
        this.getColoreBackgroundAccessibilita(idAccessibilita),
      color: this.getColoreIconaAccessibilita(idAccessibilita),
    };
  }

  geColoreStatoIntervento(statoId: number): string {
    switch (statoId) {
      case 23: // DA FINANZIARE
        return '#97D58B';
      case 24: // FINANZIATO
        return '#50C750';
      case 25: // NON FINANZIATO
        return '#FFB6C1';
      case 26: // RENDICONTATO PARZIALMENTE
        return '#87CEEB';
      case 27: // RENDICONTATO COMPLETAMENTE
        return '#218380';
      case 28: // ANNULLATO
        return '#FFBC42';
      case 29: // PRESENTATO
        return '#eabf51';
      case 30: // IN PREPARAZIONE
        return '#2196F3';
      case 31: // DA RIMODULARE
        return '#2196F3';
      case 33: // IN LIQUIDAZIONE
        return '#FFA500';
      case 34: // LIQUIDATO
        return '#008000';
      default:
        return '#218380';
    }
  }

  getIconaStatoIntervento(statoId: number): string {
    switch (statoId) {
      case 23: // DA FINANZIARE
        return 'pending';
      case 24: // FINANZIATO
        return 'payments';
      case 25: // NON FINANZIATO
        return 'cancel';
      case 26: // RENDICONTATO PARZIALMENTE
        return 'trending_up';
      case 27: // RENDICONTATO COMPLETAMENTE
        return 'done_all';
      case 28: // ANNULLATO
        return 'block';
      case 29: // PRESENTATO
        return 'assignment_turned_in';
      case 30: // IN PREPARAZIONE
        return 'edit_document';
      case 31: // DA RIMODULARE
        return 'calculate';
      case 33: // IN LIQUIDAZIONE
        return 'account_balance_wallet';
      case 34: // LIQUIDATO
        return 'paid';
      default:
        return 'help';
    }
  }

  getContenutoStatoIntervento(statoId: number): string {
    switch (statoId) {
      case 23: // DA FINANZIARE
        return 'DA FINANZIARE';
      case 24: // FINANZIATO
        return 'FINANZIATO';
      case 25: // NON FINANZIATO
        return 'NON FINANZIATO';
      case 26: // RENDICONTATO PARZIALMENTE
        return 'RENDIC. PARZ.';
      case 27: // RENDICONTATO COMPLETAMENTE
        return 'RENDIC. COMPL.';
      case 28: // ANNULLATO
        return 'ANNULLATO';
      case 29: // PRESENTATO
        return 'PRESENTATO';
      case 30: // IN PREPARAZIONE
        return 'IN PREPARAZIONE';
      case 31: // DA RIMODULARE
        return 'DA RIMODULARE';
      case 33: // IN LIQUIDAZIONE
        return 'IN LIQUIDAZIONE';
      case 34: // LIQUIDATO
        return 'LIQUIDATO';
      default:
        return 'DA FINANZIARE';
    }
  }

  getStileTipoIntervento(tipoId: number): any {
    return {
      display: 'inline-flex',
      'align-items': 'center',
      padding: '4px 12px',
      'border-radius': '16px',
      'font-size': '0.75rem',
      'font-weight': '600',
      'letter-spacing': '0.3px',
      'text-transform': 'uppercase',
      'box-shadow': '0 2px 4px rgba(0,0,0,0.05)',
      transition: 'all 0.2s ease',
      margin: '0 auto',
      width: 'fit-content',
      background: this.getGradientTipoIntervento(tipoId),
      color: '#333',
    };
  }
  getStileTipoInterventoDropdown(tipoId: number): any {
    return {
      padding: '4px 12px',
      'align-items': 'left',
      'align-content': 'left',
      'text-align': 'left',
      'border-radius': '16px',
      'font-size': '0.75rem',
      'font-weight': '600',
      'letter-spacing': '0.3px',
      'text-transform': 'uppercase',
      'box-shadow': '0 2px 4px rgba(0,0,0,0.05)',
      transition: 'all 0.2s ease',
      width: 'fit-content',
      background: this.getGradientTipoIntervento(tipoId),
      color: '#333',
    };
  }

  getGradientTipoIntervento(tipoId: number): string {
    switch (tipoId) {
      case 1: // NUOVO INTERVENTO
        return 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)';
      case 2: // MANUTENZIONE ORDINARIA
        return 'linear-gradient(135deg, #90EE90 0%, #32CD32 100%)';
      case 3: // MANUTENZIONE STRAORDINARIA
        return 'linear-gradient(135deg, #87CEEB 0%, #1E90FF 100%)';
      case 4: // VARIANTE
        return 'linear-gradient(135deg, #FFB6C1 0%, #FF69B4 100%)';
      default:
        return 'linear-gradient(135deg, #D3D3D3 0%, #A9A9A9 100%)';
    }
  }

  getIconaTipoIntervento(tipoId: number): string {
    switch (tipoId) {
      case 1: // NUOVO INTERVENTO
        return 'add_circle';
      case 2: // MANUTENZIONE ORDINARIA
        return 'build';
      case 3: // MANUTENZIONE STRAORDINARIA
        return 'construction';
      case 4: // VARIANTE
        return 'edit';
      default:
        return 'help';
    }
  }

  getStilePrioritaIntervento(priorita: number): any {
    return {
      display: 'flex',
      'align-items': 'center',
      'justify-content': 'center',
      margin: '0 auto',
      width: 'fit-content',
      color: this.getColorePriorita(priorita),
    };
  }
  getStilePrioritaInterventoInForm(priorita: number): any {
    return {
      display: 'flex',
      width: 'fit-content',
      color: this.getColorePriorita(priorita),
    };
  }

  getColorePriorita(priorita: number): string {
    switch (priorita) {
      case 1: // MASSIMA PRIORITÀ
        return '#FF0000';
      case 2: // PRIORITÀ MEDIA
        return '#FFA500';
      case 3: // MINIMA PRIORITÀ
        return '#4CAF50';
      default:
        return '#A9A9A9';
    }
  }

  getDescrizionePriorita(priorita: number): string {
    switch (priorita) {
      case 1:
        return 'MASSIMA PRIORITÀ';
      case 2:
        return 'PRIORITÀ MEDIA';
      case 3:
        return 'MINIMA PRIORITÀ';
      default:
        return 'PRIORITÀ NON DEFINITA';
    }
  }

  getIconaPrioritaIntervento(priorita: number): string {
    switch (priorita) {
      case 1: // MASSIMA PRIORITÀ
        return 'arrow_upward';
      case 2: // PRIORITÀ MEDIA
        return 'code';
      case 3: // MINIMA PRIORITÀ
        return 'arrow_downward';
      default:
        return 'help';
    }
  }
}
